<template>
  <div>
    <empty-card
      :table="true"
      :title="title"
    >
      <template slot="title">
        <b-button
          size="md"
          variant="dark"
          class="mx-md-1"
          @click="$router.push({name:'owner:poster'})"
        >
          {{ $t('poster.add-post') }}
        </b-button>
      </template>
      <ok-table
        ref="datatable"
        :config="config"
      >
        <template
          slot="image-column"
          slot-scope="{props}"
        >
          <img
            :src="props.row.picture"
            width="50"
            height="50"
          >
        </template>
        <template
          slot="type-column"
          slot-scope="{props}"
        >
          {{ $t(`poster.types.${props.row.files.length?'media':'message'}`) }}
        </template>
        <template
          slot="is_posted-column"
          slot-scope="{props}"
        >
          <b-badge :variant="props.row.is_posted?'success':'danger'">
            {{ $t(`general.${props.row.is_posted?'yes':'no'}`) }}
          </b-badge>

        </template>
        <template
          slot="error-column"
          slot-scope="{props}"
        >
          <b-badge
            v-if="props.row.status===2"
            variant="danger"
          >
            {{ props.row.error }}
          </b-badge>
          <span v-else>-</span>
        </template>
        <template
          slot="post-column"
          slot-scope="{props}"
        >
          <a
            v-if="props.row.message"
            v-b-tooltip.html.hover.bottom="props.row.full_message"
            :href="props.row.type?props.row.permalink:props.row.link"
            target="_blank"
          >
            {{ props.row.message }}
          </a>
          <span v-else> - </span>
        </template>
        <template
          slot="actions-column"
          slot-scope="{props}"
        >

          <b-button
            :variant="(props.row.reply || props.row.enabled)?'warning':'success'"
            size="sm"
            class="cursor-pointer"
            style="margin: 0 5px"
            @click="goReply(props.row)"
          >
            <span v-if="props.row.reply|| props.row.enabled">{{ $t('reply.edit') }}</span>
            <span v-else>{{ $t('reply.enable') }}</span>
          </b-button>
          <b-button
            v-b-tooltip.html.hover.bottom="{title: 'حذف'}"
            variant="danger"
            size="sm"
            class="cursor-pointer btn-icon  text-body"
            style="margin: 0 5px"
            @click="handleDelete(props.row)"
          >
            <FeatherIcon icon="TrashIcon" />
          </b-button>
          <template v-if="isSchedule && !props.row.is_posted && props.row.status!==2">
            <b-button
              v-if="!props.row.is_posted"
              v-b-tooltip.html.hover.bottom="{title: $t('instagram.post-now')}"
              variant="primary"
              size="sm"
              class="cursor-pointer btn-icon text-body"
              style="margin: 0 5px"
              @click="postNow(props.row)"
            >
              <FeatherIcon icon="LogInIcon" />
            </b-button>
            <b-button
              v-b-tooltip.html.hover.bottom="{title: $t('forms.edit')}"
              variant="warning"
              size="sm"
              class="cursor-pointer btn-icon text-body"
              style="margin: 0 5px"
              @click="$router.push({name:'owner:poster',params:{id:props.row.id}})"
            >
              <FeatherIcon icon="EditIcon" />
            </b-button>
          </template>
        </template>
      </ok-table>
    </empty-card>
  </div>
</template>

<script>
import { BButton, VBTooltip, BBadge } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import FbPosterApi from '@/api/poster'

export default {
  components: {
    EmptyCard,
    OkTable,
    BButton,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    isSchedule: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
      currentPage: 'pages/currentPage',
    }),
    title() {
      const tr = this.isSchedule ? 'schedule-posts-page-title' : 'posts-page-title'
      return this.$t(`reply.${tr}`, { page: this.currentPage.name })
    },
  },
  watch: {
    currentPageId() {
      this.refreshTable()
    },
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    goReply(row) {
      this.$router.push({ name: row.enabled ? 'owner:reply-edit' : 'owner:reply', params: { id: row.id } })
    },
    handleDelete(row) {
      this.$okConfirm(this.$t(row.type ? 'general.delete-confirm' : 'poster.delete-post-message'), {
        preConfirm: () => (row.type ? FbPosterApi.deletePostFromDB(this.currentPageId, row.id) : FbPosterApi.deletePostFromFacebook(this.currentPageId, row.id))
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    postNow(row) {
      this.$okConfirm(this.$t('poster.post-now-message'), {
        confirmButtonText: this.$t('instagram.post-now'),
        showCancel: true,
        preConfirm: () => FbPosterApi.postNow(this.currentPageId, row.id)
          .then(response => {
            if (response.error === 0) {
              this.$notifySuccess(response.message)
              this.refreshTable()
            } else {
              this.$notifyError(response.message)
            }
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
